import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import Logo from "@/components/Logo";
import { Loader2 } from "lucide-react";

const inputCls = "w-full bg-black/50 border border-smasher-gold/25 rounded-xl px-4 py-3 text-white outline-none focus:border-smasher-gold transition";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await register(form.name, form.email, form.password);
      navigate(new URLSearchParams(window.location.search).get("next") || "/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md panel p-8">
        <div className="flex justify-center mb-6"><Logo compact /></div>
        <h1 className="font-heading font-black uppercase text-3xl text-center text-gradient-gold">Join the Smashers</h1>
        <p className="text-center text-slate-400 text-sm mt-1 mb-6">Create your free account.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          {error && <div className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2" data-testid="register-error">{error}</div>}
          <input required placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} data-testid="register-name" />
          <input type="email" required placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} data-testid="register-email" />
          <input type="password" required placeholder="Password (min 6 chars)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={inputCls} data-testid="register-password" />
          <button disabled={busy} className="btn-gold w-full py-3 rounded-xl font-heading font-black tracking-wide flex items-center justify-center gap-2 disabled:opacity-60" data-testid="register-submit">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} CREATE ACCOUNT
          </button>
        </form>
        <div className="text-sm mt-4 text-center text-slate-400">
          Already a member? <Link to="/login" className="text-smasher-gold hover:text-smasher-orange">Login</Link>
        </div>
      </div>
    </div>
  );
}
